import { __assign, __rest } from "tslib";
import React, { forwardRef, useContext } from "react";
import classNames from "classnames";
import { useConfig } from "../_util/config-context";
var GridContext = React.createContext({ gap: 20 });
export var Row = forwardRef(function Row(_a, ref) {
    var _b;
    var gap = _a.gap, verticalAlign = _a.verticalAlign, showSplitLine = _a.showSplitLine, children = _a.children, className = _a.className, style = _a.style, props = __rest(_a, ["gap", "verticalAlign", "showSplitLine", "children", "className", "style"]);
    var classPrefix = useConfig().classPrefix;
    var grid = null;
    var rowStyle = null;
    // 定义了 gap 的，才生成一个 grid 上下文，否则使用默认样式即可
    if (typeof gap === "number") {
        grid = { gap: gap };
        rowStyle = {
            marginLeft: -gap / 2,
            marginRight: -gap / 2,
        };
    }
    rowStyle = __assign(__assign({}, (rowStyle || {})), (style || {}));
    var rowClassName = classNames(classPrefix + "-row", classPrefix + "-grid", className, (_b = {},
        _b[classPrefix + "-grid--split-line"] = showSplitLine,
        _b[classPrefix + "-vertical--" + verticalAlign] = verticalAlign,
        _b));
    return (React.createElement("div", __assign({ className: rowClassName, style: rowStyle }, props, { ref: ref }),
        React.createElement(GridContext.Provider, { value: grid }, children)));
});
Row.displayName = "Row";
export var Col = forwardRef(function Col(_a, ref) {
    var _b;
    var xs = _a.xs, sm = _a.sm, md = _a.md, lg = _a.lg, xl = _a.xl, xxl = _a.xxl, _c = _a.span, span = _c === void 0 ? xs : _c, className = _a.className, style = _a.style, children = _a.children, props = __rest(_a, ["xs", "sm", "md", "lg", "xl", "xxl", "span", "className", "style", "children"]);
    var classPrefix = useConfig().classPrefix;
    var grid = useContext(GridContext);
    var colStyle = null;
    if (grid) {
        colStyle = {
            paddingLeft: grid.gap / 2,
            paddingRight: grid.gap / 2,
        };
    }
    var colClassName = classNames(classPrefix + "-col", classPrefix + "-grid__item" + (span != null ? "-" + span : ""), (_b = {},
        _b[classPrefix + "-grid__item-xs-" + xs] = xs != null,
        _b[classPrefix + "-grid__item-sm-" + sm] = sm != null,
        _b[classPrefix + "-grid__item-md-" + md] = md != null,
        _b[classPrefix + "-grid__item-lg-" + lg] = lg != null,
        _b[classPrefix + "-grid__item-xl-" + xl] = xl != null,
        _b[classPrefix + "-grid__item-xxl-" + xxl] = xxl != null,
        _b), className);
    colStyle = __assign(__assign({}, (colStyle || {})), (style || {}));
    // 有改变内层属性需求，文档不暴露该属性
    var _d = props, _e = _d.innerProps, innerProps = _e === void 0 ? {} : _e, restProps = __rest(_d, ["innerProps"]);
    return (React.createElement("div", __assign({ className: colClassName, style: colStyle }, restProps, { ref: ref }),
        React.createElement("div", __assign({}, innerProps, { className: classNames(classPrefix + "-grid__box", innerProps === null || innerProps === void 0 ? void 0 : innerProps.className) }), children)));
});
Col.displayName = "Col";
//# sourceMappingURL=Grid.js.map